/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 21V3h20v18zm4-4H4v2h2zM16 5H8v14h8zm2 14h2v-2h-2zM6 13H4v2h2zm14 0h-2v2h2zM6 9H4v2h2zm14 0h-2v2h2zM6 5H4v2h2zm14 0h-2v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFilm as Film };
